import { render, staticRenderFns } from "./ViewAllServices.vue?vue&type=template&id=17b151c2"
import script from "./ViewAllServices.vue?vue&type=script&lang=js"
export * from "./ViewAllServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports